import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'
import moment from 'moment'
import DataUtils from '@/utils/DataUtils'
import ConfirmDialogPreset from '@/components/autoImport/ConfirmDialogPreset'

const C11101T3010ChatroomCheckModule = {
  state: {
    C11101_t3010ChatroomCheck_output: {
      rows: []
    },
  },
  getters: {
    C11101_t3010ChatroomCheck_getData(state) {
      return state.sectionScheduleTableData.lessons.map(item => {
        return {
          rel_id: item.id
        }
      })
    },
    C11101_t3010ChatroomCheck_getMessageCount: (state) => (id) => {
      if(!state.C11101_t3010ChatroomCheck_output.rows || !Array.isArray(state.C11101_t3010ChatroomCheck_output.rows)) {
        return 0;
      }
      const item = state.C11101_t3010ChatroomCheck_output.rows.find(item => item.rel_id === id);
      if (item)
        return item.message_count || 0;

      return 0;
    }
  },
}

const C11101StudentJoinCheckModule={
  state: {
    C11101_StudentJoinCheck_output: [],
  },
  getters: {
  },
  actions: {
  }
}

const C11101T2050Module = {
  state:{
    C11101T2050_rows: [],
    C11101T2050_map: {},
  },
  mutations: {
    set_C11101T2050_map: (state) => {
      const output = {};
      state.C11101T2050_rows.forEach(t2050 => {
        const key = `${t2050.schedule_date}_${t2050.time_limit_no}_${t2050.teacher_no}`;
        if(t2050._action === 'delete') return; // skip delete action
        output[key] = true;
      });
      state.C11101T2050_map = Object.freeze(output);
    },
  },
  actions:{
    async C11101T2050_setWork({ state, commit },{
      schedule_date,
      time_limit_no,
      teacher_no,
      timeGroup,
      timeLimit
    }){
      if (!schedule_date) throw new Error('schedule_date is required');
      if (!time_limit_no) throw new Error('time_limit_no is required');
      if (!teacher_no) throw new Error('teacher_no is required');
      const key = `${schedule_date}_${time_limit_no}_${teacher_no}`;

      console.debug('C11101T2050_setWork', {
        schedule_date,
        time_limit_no,
        teacher_no,
        timeGroup,
        timeLimit
      })

      const exist = state.C11101T2050_map[key];

      const ok = await window.vue.$confirm({
        ...ConfirmDialogPreset.baseConfirm(window.vue),
        text: window.vue.$i18n.t('C11101.C11101Store.timelimittimelimitnamewodeshimasuyoroshiidesukannorishihaheshitekudasai', [timeLimit.time_limit_name]),
      })
      if (!ok) {
        return;
      }


      const res = await $this.$api.postData({
        data: [
          {
            api: 'T2050OthersScheduleService.C11101T2050_setWork',
            input: {
              schedule_date,
              time_limit_no,
              teacher_no
            }
          },
        ]
      })

      console.debug({
        res,
        key,
        exist
      })
      if (exist) {
        const row = state.C11101T2050_rows.find(r => r.schedule_date === schedule_date && r.time_limit_no === time_limit_no && r.teacher_no === teacher_no);
        const index = state.C11101T2050_rows.indexOf(row);
        state.C11101T2050_rows[index]._action = 'delete'
      } else{
        const newRow = {
          schedule_date,
          time_limit_no,
          teacher_no,
          timeDivision: time_limit_no % 10,
        }
        state.C11101T2050_rows.push(newRow);
      }
      commit('set_C11101T2050_map')
      window.vue.$dialog.notify.success(window.vue.$i18n.t('C11101.C11101Store.woshimashita'));
    }

  }
}


const module = {
  state: {
    initInfo: {
      teacher_no: null,
      center_no: null,
      date: moment().format('YYYY-MM-DD'),
    },
    sectionLessonPendingCountData:{
      contact_message: 0,
      notice_count: 0,
      student_request: 0,
      outstanding_lesson_report: 0,
      resubmitted_lesson_report_required: 0
    },
    sectionTeacherAttendanceData:{
      start_time: null
    },
    sectionJoinedStudentData:{
      schedule_account_no_list: []
    },
    sectionScheduleTableData:{
      time_limits: [],
      lessons: [],
    },
    renderKey: 0,
  },

  getters: {
    isAttendanceConfirmed (state) {
      return state.sectionTeacherAttendanceData.start_time !== '00:00'
    },
    getCurrentTeacherClass(state){
      return state.sectionScheduleTableData.lessons
    },
  },

  mutations: {
    SET_INIT_INFO (state, payload) {
      state.initInfo = payload
    },
    SET_RENDER_KEY (state) {
      state.renderKey = DataUtils.randomString(10)
    }
  },
  actions: {
    async C11101_fetch ({ commit, state }) {
      const res = await $this.$api.postData({
        data:
        {
          init: {
            api: 'T2040TeacherScheduleService.C11101_initData',
            input: {
              teacher_no:state.initInfo.teacher_no,
              schedule_date:state.initInfo.date
            }
          }
        }
      })
      const data = res.init.output
      commit('setState', {
        renderKey : DataUtils.randomString(10),
        sectionLessonPendingCountData: data.sectionLessonPendingCountData,
        sectionTeacherAttendanceData: data.sectionTeacherAttendanceData,
        sectionJoinedStudentData: data.sectionJoinedStudentData,
        sectionScheduleTableData: data.sectionScheduleTableData,
        C11101T2050_rows: data.sectionScheduleTableData.t2050_others_schedule,
      })

      commit('set_C11101T2050_map')
    },
  }
}

export default ObjArrUtils.merge(Base, module,C11101T3010ChatroomCheckModule,C11101T2050Module,C11101StudentJoinCheckModule)
